import React, { memo } from 'react';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';

import Stack from '@mui/material/Stack';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Tooltip from '@mui/material/Tooltip';

import SelectMonthYear from './action/SelectMonthYear';
import BtnOutlineGradient from 'src/components/common/button/BtnOutlineGradient';
import { useStore } from 'src/context/StoreContext';
import { getField } from 'src/common/helper';

type ActionCalendarProps = {
  yearMonth: string;
  urls: any;
  onChangeMonth: (yearMonth: string) => void;
  onClickToDay: () => void;
  offTab?: boolean;
};

const ActionCalendar: React.FC<ActionCalendarProps> = (props) => {
  const navigate = useNavigate();
  const storeContext = useStore();
  const tabCalendar = storeContext.tabCalendar;

  const handleChangeTab = (tab: 'calendar' | 'schedule') => () => {
    if (tab === 'calendar') {
      navigate(getField(props.urls, 'calendar', ''));
    } else {
      navigate(getField(props.urls, 'schedule', ''));
    }
  }

  return (
    <Stack
      direction={'row'}
      alignContent={'center'}
      justifyContent={'space-between'}
    >
      <Stack
        direction={'row'}
        alignContent={'center'}
        justifyContent={'center'}
      >
        <BtnOutlineGradient
          text='本日に戻る'
          sx={{
            width: '82px',
            height: '32px',
            m: 'auto'
          }}
          handleButtonClick={() => props.onClickToDay()}
        />
        <SelectMonthYear currentMonth={dayjs(props.yearMonth)} onMonthChange={props.onChangeMonth} />
      </Stack>
      {!props.offTab && (
        <Stack
          direction={'row'}
          alignContent={'center'}
          justifyContent={'center'}
          sx={{
            bgcolor: '#FFFFFF',
            borderRadius: '16px',
            height: '40px',
            width: '112px'
          }}
        >
          <Tooltip
            title={'カレンダー画面に切り替える'}
            arrow
            componentsProps={{
              tooltip: {
                sx: {
                  bgcolor: '#434154',
                  color: '#FFFFFF',
                },
              },
              arrow: {
                sx: {
                  color: '#434154',
                },
              },
            }}
          >
            <IconButton onClick={handleChangeTab('calendar')}>
              <Box
                component={'img'}
                src={tabCalendar === 'calendar' ? '/images/ic-calendar-31-active.svg' : '/images/ic-calendar-31.svg'}
                alt='Calendar'
                sx={{ width: '24px', height: '24px' }}
              />
            </IconButton>
          </Tooltip>
          <Divider orientation='vertical' flexItem sx={{ bgcolor: '#E6E9ED' }} />
          <Tooltip
            title={'勤怠入力画面に切り替える'}
            arrow
            componentsProps={{
              tooltip: {
                sx: {
                  bgcolor: '#434154',
                  color: '#FFFFFF',
                },
              },
              arrow: {
                sx: {
                  color: '#434154',
                },
              },
            }}
          >
            <IconButton onClick={handleChangeTab('schedule')}>
              <Box
                component={'img'}
                src={tabCalendar === 'schedule' ? '/images/ic-calendar-attendance-active.svg' : '/images/ic-calendar-attendance.svg'}
                alt='attendance'
                sx={{ width: '24px', height: '24px' }}
              />
            </IconButton>
          </Tooltip>
        </Stack>
      )}
    </Stack >
  );
}

export default memo(ActionCalendar);